import { t } from "i18next";
import { isEmpty, pick } from "lodash";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import AuthContext from "../../context/AuthContext";
import { validationRules } from "../../Utils/Toast";
import { Form } from "react-bootstrap";
import ThemeContext from "../../context/ThemeContext";
import OutsideClickHandler from "react-outside-click-handler";
const ResetPassword = () => {
  const navigate = useNavigate();
  const preventMaxInput = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const [showPassword, setShowPassword] = useState({
    first: false,
    second: false,
    third: false,
  });
  const handleShow = (id) => {
    setShowPassword({ ...showPassword, [id]: !showPassword[id] });
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm({});
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);
  const onSubmit = async (body) => {
    const obj = pick(body, ["oldPassword", "newPassword"]);
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        logoutUser();
        navigate("/");
      } else {
        setToastObject({
          type: "error",
          title: "Bet Error",
          message: data?.message,
          status: true,
        });
      }
    } else {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: data?.message,
        status: true,
      });
    }
  };
  return ReactDOM.createPortal(
    <app-popup-page
      _ngcontent-serverapp-c4268204220
      className="ng-tns-c4268204220-0 popup-page-wrapper active"
      _nghost-serverapp-c2790459173
    >
      <div
        _ngcontent-serverapp-c2790459173
        className="popup-page popup-page--active popup-page--align-top"
      >
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__backdrop"
        />  <OutsideClickHandler onOutsideClick={() => navigate(-1)}>
        
        <div
          _ngcontent-serverapp-c2790459173
          className="popup-page__main popup-page-main popup-page-main--show"
        >
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__header"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__title"
            >
              {t("ResetPassword")}
            </div>
            <div
              onClick={() => navigate("/")}
              _ngcontent-serverapp-c2790459173
              className="popup-page-main__close ng-star-inserted"
            />
          </div>
          <div
            _ngcontent-serverapp-c2790459173
            className="popup-page-main__container"
          >
            <div
              _ngcontent-serverapp-c2790459173
              className="content member-content"
            >
              <app-change-password
                _nghost-serverapp-c2292208966
                className="ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c2292208966
                  className="logo-box ng-star-inserted"
                  style={{
                    backgroundImage:
                      theme == "light"
                        ? `url("/assets/Other/logo-light.png")`
                        : `url("/assets/Other/logo.png")`,
                  }}
                />
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  _ngcontent-serverapp-c2292208966
                  noValidate="novalidate"
                  className="ng-untouched ng-pristine ng-invalid ng-star-inserted"
                >
                  <div style={{background:'transparent'}} _ngcontent-serverapp-c2292208966 className="menu-box">
                    <div
                      _ngcontent-serverapp-c2292208966
                      className="input-group password ng-star-inserted"
                    >
                      <div
                        onClick={() => handleShow("first")}
                        _ngcontent-serverapp-c2292208966
                        className={`eyes ${
                          showPassword?.first ? "active" : ""
                        } `}
                      />
                      <label _ngcontent-serverapp-c2292208966>
                        {t("Currentpassword")}
                      </label>
                      <input
                        _ngcontent-serverapp-c2292208966
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={showPassword?.first ? "text" : "password"}
                        maxLength={20}
                        minLength={6}
                        onInput={(e) => preventMaxInput(e)}
                        placeholder={t("Currentpassword")}
                        {...register("oldPassword", {
                          required: t("Pleaseentercurrentpassword"),
                          validate: (value) => {
                            if (value === "") {
                              return true;
                            }
                            if (!!value.trim()) {
                              return true;
                            } else {
                              return t("WhiteSpace");
                            }
                          },
                          pattern: {
                            value: validationRules.password,
                            message: t("PasswordLineRule1"),
                          },
                        })}
                      />
                      {errors.oldPassword && errors.oldPassword.message && (
                        <div style={{ marginTop: "3px" }} className="alert">
                          {errors.oldPassword.message}
                        </div>
                      )}
                    </div>

                    <div
                      _ngcontent-serverapp-c2292208966
                      className="input-group password"
                    >
                      <div
                        onClick={() => handleShow("second")}
                        _ngcontent-serverapp-c2292208966
                        className={`eyes ${
                          showPassword?.second ? "active" : ""
                        } `}
                      />
                      <label _ngcontent-serverapp-c2292208966>
                        {t("Newpassword")}
                      </label>
                      <input
                        _ngcontent-serverapp-c2292208966
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={showPassword?.second ? "text" : "password"}
                        placeholder={t("Newpassword")}
                        maxLength={20}
                        minLength={6}
                        onInput={(e) => preventMaxInput(e)}
                        {...register("newPassword", {
                          required: t("Pleaseenternewpassword"),
                          validate: (value) => {
                            if (value === "") {
                              return true;
                            }
                            if (!!value.trim()) {
                              return true;
                            } else {
                              return t("WhiteSpace");
                            }
                          },
                          pattern: {
                            value: validationRules.password,
                            message: t("PasswordLineRule1"),
                          },
                        })}
                      />{" "}
                      {errors.newPassword && errors.newPassword.message && (
                        <div style={{ marginTop: "3px" }} className="alert">
                          {errors.newPassword.message}
                        </div>
                      )}
                    </div>
                    <div
                      _ngcontent-serverapp-c2292208966
                      className="input-group password"
                    >
                      <div
                        onClick={() => handleShow("third")}
                        _ngcontent-serverapp-c2292208966
                        className={`eyes ${
                          showPassword?.third ? "active" : ""
                        } `}
                      />
                      <label _ngcontent-serverapp-c2292208966>
                        {t("Confirmnewpassword")}
                      </label>
                      <input
                        _ngcontent-serverapp-c2292208966
                        className="input ng-untouched ng-pristine ng-invalid"
                        type={showPassword?.third ? "text" : "password"}
                        placeholder={t("Confirmnewpassword")}
                        onInput={(e) => preventMaxInput(e)}
                        maxLength={20}
                        minLength={6}
                        {...register("confirmPassword", {
                          required: {
                            value: true,
                            message: t("Pleaseenterconfirmpassword"),
                          },
                          validate: (value) => {
                            if (value === "") {
                              return true;
                            }
                            if (!isEmpty(watch("newPassword"))) {
                              if (value == watch("newPassword")) {
                                return true;
                              } else {
                                return t("PasswordMatch");
                              }
                            }
                          },
                        })}
                        onChange={(e) => {
                          setValue("confirmPassword", e.target.value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {errors.confirmPassword &&
                        errors.confirmPassword.message && (
                          <div style={{ marginTop: "3px" }} className="alert">
                            {errors.confirmPassword.message}
                          </div>
                        )}
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c2292208966
                    className="accordion-wrap tips show"
                  >
                    <div
                      _ngcontent-serverapp-c2292208966
                      className="a-title toggle-btn"
                    >
                      <div
                        _ngcontent-serverapp-c2292208966
                        className="a-icon"
                        style={{
                          "mask-image":
                            'url("/assets/Other/accordion-tips.svg")',
                        }}
                      />
                      <div _ngcontent-serverapp-c2292208966 className="a-text">
                        {t("Passwordrequirements")}
                      </div>
                      <div
                        _ngcontent-serverapp-c2292208966
                        className="a-arrow"
                        style={{
                          "mask-image":
                            'url("/assets/Other/accordion-arrow.svg")',
                        }}
                      />
                    </div>
                    <div _ngcontent-serverapp-c2292208966 className="a-content">
                      <ol _ngcontent-serverapp-c2292208966 className="a-list">
                        <li _ngcontent-serverapp-c2292208966 className="a-item">
                          {t("Mustlong")}.
                        </li>
                        <li
                          _ngcontent-serverapp-c2292208966
                          className="a-item ng-star-inserted"
                        >
                          {t("Password1")}.
                        </li>
                        <li
                          _ngcontent-serverapp-c2292208966
                          className="a-item ng-star-inserted"
                        >
                          {t("Password2")}
                        </li>

                        <li _ngcontent-serverapp-c2292208966 className="a-item">
                          {t("Password3")}
                        </li>
                        <li _ngcontent-serverapp-c2292208966 className="a-item">
                          {t("Password4")}
                        </li>
                      </ol>
                    </div>
                  </div>
                  <button
                    type="submit"
                    _ngcontent-serverapp-c2292208966
                    className="button btn-primary"
                    style={{ border: "none" }}
                  >
                    <a _ngcontent-serverapp-c2292208966>{t("Confirm")}</a>
                  </button>
                </Form>
              </app-change-password>
            </div>
          </div>
        </div></OutsideClickHandler>
      </div>
    </app-popup-page>,
    document.getElementById("overlay")
  );
};

export default ResetPassword;
